import { ERouterNames } from '@/types';

export const pathWithoutNavBarAndTopPanel = [
  ERouterNames.WAITING_ROOM,
  ERouterNames.CHAT,
  ERouterNames.MEDICAL_STAFF_CHAT,
  ERouterNames.PAYMENTS_INITIALIZE,
  ERouterNames.PAYMENT_CALLBACK,
  ERouterNames.INVITE_LINK,
  ERouterNames.FORM_BUILDER_ENTRY_EDIT,
  ERouterNames.FORM_BUILDER_ENTRY_VIEW,
  ERouterNames.PATIENT_DOSESPOT,
  ERouterNames.ENCOUNTER,
  ERouterNames.MEDICAL_STAFF_ENCOUNTER,
  `${ERouterNames.CHAT}/${ERouterNames.SESSION_ENDED}`,
  `${ERouterNames.MEDICAL_STAFF_CHAT}/${ERouterNames.SESSION_ENDED}`,
  `${ERouterNames.ENCOUNTER}/${ERouterNames.SESSION_ENDED}`,
  `${ERouterNames.MEDICAL_STAFF_ENCOUNTER}/${ERouterNames.SESSION_ENDED}`,
  `${ERouterNames.DOCUMENT_MANAGEMENT}/${ERouterNames.FORM_BUILDER}`,
  `${ERouterNames.DOCUMENT_MANAGEMENT}/${ERouterNames.FORM_BUILDER_PREVIEW}`,
  `${ERouterNames.WAITING_ROOM}/${ERouterNames.LEFT}`,
  ERouterNames.VISIT_NOTE_TEMPLATE_EDIT,
  ERouterNames.VISIT_NOTE_TEMPLATE_PREVIEW,
  ERouterNames.APPOINTMENT__JOIN,
];
